import { jsx as l, jsxs as i } from "react/jsx-runtime";
import "react";
var a = (t) => /* @__PURE__ */ i("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...t,
  children: [
    /* @__PURE__ */ l("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ l("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1526 -536)",
      fill: "white"
    }),
    /* @__PURE__ */ l("path", {
      d: "M19.9997 0H0V20H19.9997V0Z",
      fill: "#0052B4"
    }),
    /* @__PURE__ */ l("path", {
      d: "M6.66655 0H0V20H6.66655V0Z",
      fill: "#A2001D"
    }),
    /* @__PURE__ */ l("path", {
      d: "M19.9996 0H13.333V20H19.9996V0Z",
      fill: "#A2001D"
    }),
    /* @__PURE__ */ l("path", {
      d: "M5.38168 10.5492H4.64941V13.4783H5.38168V10.5492Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ l("path", {
      d: "M2.452 10.5492H1.71973V13.4783H2.452V10.5492Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ l("path", {
      d: "M3.55063 12.3797C3.95505 12.3797 4.2829 12.0518 4.2829 11.6474C4.2829 11.243 3.95505 10.9152 3.55063 10.9152C3.14621 10.9152 2.81836 11.243 2.81836 11.6474C2.81836 12.0518 3.14621 12.3797 3.55063 12.3797Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ l("path", {
      d: "M3.5507 9.45089C3.75292 9.45089 3.91684 9.28697 3.91684 9.08476C3.91684 8.88255 3.75292 8.71863 3.5507 8.71863C3.34849 8.71863 3.18457 8.88255 3.18457 9.08476C3.18457 9.28697 3.34849 9.45089 3.5507 9.45089Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ l("path", {
      d: "M4.2829 12.7461H2.81836V13.4784H4.2829V12.7461Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ l("path", {
      d: "M4.2829 9.81689H2.81836V10.5492H4.2829V9.81689Z",
      fill: "#FFDA44"
    }),
    /* @__PURE__ */ l("path", {
      d: "M3.55055 6.52173L3.80989 7.3197H4.64892L3.97016 7.81298L4.2293 8.61099L3.55055 8.11774L2.87176 8.61099L3.13094 7.81298L2.45215 7.3197H3.29118L3.55055 6.52173Z",
      fill: "#FFDA44"
    })
  ]
});
export {
  a as default
};
